import React, { Component } from 'react';
import HtmlHelpers from '../HtmlHelpers';
import LinksActionMenu from '../LinksActionMenu';
export default class LinksActionData extends Component {
  constructor() {
    super(...arguments);
    this.menuItems = () => {};
    this.tooltip = (reasons, type) => reasons.length > 0 ? /*#__PURE__*/React.createElement("div", null, reasons.map((reason, idx) => this.reasonMsg(reason, type, idx))) : null;
    this.reasonMsg = (reason, type, idx) => /*#__PURE__*/React.createElement("div", {
      key: "reason_".concat(type).concat(idx)
    }, "-", ' ', reason);
    this.buildInfo = (info, label, action) => HtmlHelpers.isEmpty(info) ? '' : {
      label,
      action,
      disabled: info.disabled,
      tooltip: this.tooltip(info.reasons)
    };
    this.dropdownLabel = () => 'Actions';
  }
  render() {
    return HtmlHelpers.isEmpty(this.menuItems()) ? '' : /*#__PURE__*/React.createElement(LinksActionMenu, {
      menuItems: this.menuItems(),
      dropdownLabel: this.dropdownLabel()
    });
  }
}